import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ApplicationClientCommonModule, MaterialModule } from '@sdbn/appclient';
import { DictionaryModule } from '@sdbn/appclient';
import { CommonTranslationModule } from '@sdbn/common';
import { AdditionalVisitorComponent } from './component/additional-visitor.component';
import { CenteredScrollableContentModule } from 'src/tmc-common/widgets/terminal/centered-scrollable-content/centered-scrollable-content.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';


@NgModule({
  declarations: [
    AdditionalVisitorComponent
  ],
  imports: [
    CommonModule,
    CenteredScrollableContentModule,
    DictionaryModule,
    MaterialModule,
    FormsModule,
    ReactiveFormsModule,
    ApplicationClientCommonModule,
    CommonTranslationModule,
  ]
})
export class AdditionalVisitorModule { }
